import React, {useState, useEffect} from 'react';
import { Form, Select } from "antd";
import { getStocksAsSelect } from "../../../services/serviceStock";
import { getBrandsAsSelect } from "../../../services/serviceBrand";
import { getAllWarehouse } from "../../../services/serviceWarehouse";

const NotInvolvedBrandFilter = () => {
    const [stocks, setStocks] = useState([]);
    const [brands, setBrands] = useState([]);
    const [warehouse, setWarehouse] = useState([]);

    useEffect(() => {
        getStocksAsSelect()
            .then(({data}) => {
                if(data && data.length) {
                    const structured = data.map((item) => ({value: item.key, label:item.label}));
                    setStocks(structured);
                }
            })
    }, [])

    useEffect(() => {
        getBrandsAsSelect()
            .then(({data}) => {
                if(data && data.length) {
                    const structured = data.map((item) => ({value: item.key, label:item.label}));
                    setBrands(structured);
                }
            })
    }, [])

    useEffect(() => {
        getAllWarehouse()
            .then(({data}) => {
                if(data && data.length) {
                    const structured = data.map((item) => ({value: item.id, label:item.code}));
                    setWarehouse(structured);
                }
            })
    }, [])

    const selectSearch = (input, option) => {
        return (option?.label ?? '').toLowerCase().includes(input.toLowerCase());
    }

    return(
        <React.Fragment>
            <Form.Item
                name={'stockId'}
                label={'Stok Adı'}
            >
                <Select showSearch options={stocks} filterOption={selectSearch} />
            </Form.Item>
            <Form.Item
                name={'warehouseId'}
                label={'Depo Adı'}
            >
                <Select showSearch options={warehouse} filterOption={selectSearch}/>
            </Form.Item>
            <Form.Item
                name={'brandId'}
                label={'Marka Adı'}
            >
                <Select showSearch options={brands} filterOption={selectSearch}/>
            </Form.Item>
        </React.Fragment>
    )
}
export default NotInvolvedBrandFilter